import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ButtonBase from "@mui/material/ButtonBase";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ComponentErrorBoundary } from "core/components/ComponentErrorBoundary";
import {
  GridAreaContainer,
  type GridAreaContainerProps,
} from "core/components/GridAreaContainer";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { SuggestionBoxDialog } from "./SuggestionBoxDialog";

const GRID_AREA = "suggest";

function Wrapper({
  children,
  containerProps,
}: {
  children: ReactNode;
  containerProps?: GridAreaContainerProps;
}) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:SuggestionBoxWidget",
  });
  return (
    <ComponentErrorBoundary fallBackBoxProps={{ sx: { gridArea: GRID_AREA } }}>
      <GridAreaContainer
        {...containerProps}
        gridArea={GRID_AREA}
        title={t("gridAreaContainerTitle", "Suggestion Box")}
      >
        {children}
      </GridAreaContainer>
    </ComponentErrorBoundary>
  );
}

export function SuggestionBoxWidget({
  containerProps,
}: {
  containerProps?: GridAreaContainerProps;
}) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:SuggestionBoxWidget",
  });

  return (
    <Wrapper containerProps={containerProps}>
      <ButtonBase
        onClick={() => setOpen(true)}
        sx={{
          height: "auto",
          width: "100%",
          maxWidth: "350px",
          textAlign: "center",
          mx: "auto",
          containerType: "inline-size",
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            p: 3,
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: "primary.main",
          }}
        >
          <Stack alignItems="center" spacing={1}>
            <Typography color="primary.main" fontSize="12cqi">
              {t("widgetTitle", "Share An Idea")}
            </Typography>
            <LightbulbOutlinedIcon
              sx={{ fontSize: "35cqi", color: "primary.main" }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              fontSize="7cqi"
              p={0}
              m={0}
            >
              {t("widgetSubtitle", "Help to improve Pitstop")}
            </Typography>
          </Stack>
        </Paper>
      </ButtonBase>
      <SuggestionBoxDialog open={open} onClose={() => setOpen(false)} />
    </Wrapper>
  );
}
